import axios from 'axios';
import {doc, updateDoc} from 'firebase/firestore';
import db from "../../config/firebase";

// initialState
const initialState = {
    clientEdited: {},
    userEdited: {},
    levelEdited: {},
    roomEdited: {},
    categoryEdited: {},
    reservationEdited: {},
    roomCleaned: {},
    roomOccupied: {}
}

// types
const EDIT_CLIENT = 'EDIT_CLIENT',
      EDIT_USER = 'EDIT_USER',
      EDIT_LEVEL = 'EDIT_LEVEL',
      EDIT_ROOM = 'EDIT_ROOM',
      EDIT_CATEGORY = 'EDIT_CATEGORY',
      EDIT_RESERVATION = 'EDIT_RESERVATION',
      OPEN_ROOM = 'OPEN_ROOM',
      OCUPPY_ROOM = 'OCUPPY_ROOM';

// reducer
const editClientReducer = (state=initialState, action) => {
    switch(action.type){
        case 'EDIT_CLIENT': return{
            ...state,
            clientEdited: action.payload
        }
        case 'EDIT_USER': return{
            ...state,
            userEdited: action.payload
        }
        case 'EDIT_LEVEL': return{
            ...state,
            levelEdited: action.payload
        }
        case 'EDIT_ROOM': return{
            ...state,
            roomEdited: action.payload
        }
        case 'EDIT_CATEGORY': return{
            ...state,
            categoryEdited: action.payload
        }
        case 'EDIT_RESERVATION': return{
            ...state,
            reservationEdited: action.payload
        }
        case 'OPEN_ROOM': return{
            ...state,
            roomCleaned: action.payload
        }
        case 'OCUPPY_ROOM': return{
            ...state,
            roomOccupied: action.payload
        }
        default: return state;
    }
}

// action
const editClientAction = (clientEdited, dataNames, id) => async (dispatch, getState) => {

    try {
        // creating object
        let clientObject = {};

        dataNames.map((element, index) => {
            clientObject[element] = clientEdited.get(element);
        });
  
        const clientEditedRef = doc(db, "client", `${id}`);
        await updateDoc(clientEditedRef, clientObject);

        // adding to state
        dispatch({
            type: EDIT_CLIENT,
            payload: clientObject
        })
    } catch (error) {
        console.log(error)
    }
}

const editUserAction = (userEdited, dataNames, id) => async (dispatch, getState) => {

    try {
        // creating object
        let userObject = {};

        dataNames.map((element, index) => {
            userObject[element] = userEdited.get(element);
        });
  
        const userEditedRef = doc(db, "user", `${id}`);
        await updateDoc(userEditedRef, userObject);

        // adding to state
        dispatch({
            type: EDIT_USER,
            payload: userObject
        })
    } catch (error) {
        console.log(error)
    }  

}

const editLevelAction = (levelEdited, dataNames, id) => async (dispatch, getState) => {
    try {
        // creating object
        let levelObject = {};

        dataNames.map((element, index) => {
            levelObject[element] = levelEdited.get(element);
        });
  
        const levelEditedRef = doc(db, "level", `${id}`);
        await updateDoc(levelEditedRef, levelObject);

        // adding to state
        dispatch({
            type: EDIT_LEVEL,
            payload: levelObject
        })
    } catch (error) {
        console.log(error)
    }  
}

const editRoomAction = (roomEdited, dataNames, id) => async (dispatch, getState) => {

    try {
        // creating object
        let roomObject = {};

        dataNames.map((element, index) => {
            roomObject[element] = roomEdited.get(element);
        });

        roomObject['id'] = id;
  
        const roomEditedRef = doc(db, "room", `${id}`);
        await updateDoc(roomEditedRef, roomObject);

        // adding to state
        dispatch({
            type: EDIT_ROOM,
            payload: roomObject
        })
    } catch (error) {
        console.log(error)
    }  

}

const editCategoryAction = (categoryEdited, dataNames, id) => async (dispatch, getState) => {

    try {
        // creating object
        let categoryObject = {};

        dataNames.map((element, index) => {
            categoryObject[element] = categoryEdited.get(element);
        });
  
        const categoryEditedRef = doc(db, "category", `${id}`);
        await updateDoc(categoryEditedRef, categoryObject);

        // adding to state
        dispatch({
            type: EDIT_CATEGORY,
            payload: categoryObject
        })
    } catch (error) {
        console.log(error)
    }  
}

const editReservationAction = (reservationEdited, dataNames, id) => async (dispatch, getState) => {
    try {
        // creating object
        let reservationObject = {};

        dataNames.map((element, index) => {
            reservationObject[element] = reservationEdited.get(element);
        });
  
        const reservationEditedRef = doc(db, "reservation", `${id}`);
        await updateDoc(reservationEditedRef, reservationObject);

        // adding to state
        dispatch({
            type: EDIT_RESERVATION,
            payload: reservationObject
        })
    } catch (error) {
        console.log(error)
    }  
}

const openThisRoom = (roomEdited, dataNames, id) => async (dispatch, getState) => {
    try {
        // creating object
        let roomObject = {};

        dataNames.map((element, index) => {
            roomObject[element] = roomEdited.get(element);
        });

        roomObject['id'] = id;
  
        const roomEditedRef = doc(db, "room", `${id}`);
        await updateDoc(roomEditedRef, roomObject);

        // adding to state
        dispatch({
            type: OPEN_ROOM,
            payload: roomObject
        })
    } catch (error) {
        console.log(error)
    }   
}

const occupyThisRoom = (roomEdited, dataNames, id) => async (dispatch, getState) => {
    try {
        // creating object
        let roomObject = {};

        dataNames.map((element, index) => {
            roomObject[element] = roomEdited.get(element);
        });

        roomObject['id'] = id;
  
        const roomOEditedRef = doc(db, "room", `${id}`);
        await updateDoc(roomOEditedRef, roomObject);

        // adding to state
        dispatch({
            type: OCUPPY_ROOM,
            payload: roomObject
        })
    } catch (error) {
        console.log(error)
    }   

}

// export
export { editClientAction, editUserAction, editLevelAction, editRoomAction, editCategoryAction, editReservationAction, openThisRoom, occupyThisRoom }

export default editClientReducer;